import { ItemInstance } from '@headless-tree/core';
import { FileItemType } from '../../types';

export const getItemName = <T extends FileItemType>(
  item: ItemInstance<T>
): string => item.getItemData().name;
